import styled from 'styled-components'

import { CloseButton, PrimaryButton } from '../buttons/Buttons'
import { palette, fonts, mediaQueries, shadows } from '../../styles/variables'
import { translate } from '../../utils/translation'
import NavigationGif from '../../styles/assets/nav-gif.gif'

import Modal, { ModalContent } from './Modal'

const Title = styled.span({
  color: palette.darkGray,
  fontSize: 32,
  lineHeight: '32px',
  fontWeight: 400,
  fontFamily: fonts.primaryMedium,
  textAlign: 'left',
  [mediaQueries.mobile]: {
    textAlign: 'center',
    fontSize: '24px',
    lineHeight: '24px',
  },
})

const Text = styled.span({
  display: 'block',
  color: palette.darkGray,
  fontSize: 16,
  lineHeight: '28px',
  fontFamily: fonts.primaryLight,
  textAlign: 'left',
  marginTop: '24px',
  whiteSpace: 'pre-wrap',
  [mediaQueries.mobile]: {
    textAlign: 'center',
  },
})

const TextRow = styled.div({
  marginTop: '52px',
  [mediaQueries.mobile]: {
    marginBottom: '52px',
    display: 'flex',
    flexDirection: 'column',
  },
})

const desktopStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  width: '960px',
  maxWidth: '90%',
  overflow: 'hidden',
  boxShadow: shadows.shadowA,
  borderRadius: '0',
}

const mobileStyle = {
  width: '90%',
  height: 'auto',
  display: 'block',
}

const LeftPanelWrapper = styled.div({
  background: palette.orange,
  padding: '128px 132px 0',
  [mediaQueries.tablet]: {
    padding: '25% 25% 0',
  },
  [mediaQueries.mobile]: {
    display: 'none',
  },
})

const NavigationGifImage = styled.img({
  display: 'block',
  marginBottom: '-1px',
  [mediaQueries.tablet]: {
    width: '100%',
  },
})

const CustomModalContent = styled(ModalContent)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
})

export default ({ isOpen, onClose, ...rest }) => (
  <Modal
    isOpen={isOpen}
    desktopStyle={desktopStyle}
    mobileStyle={mobileStyle}
    {...rest}
  >
    <LeftPanelWrapper>
      <NavigationGifImage src={NavigationGif} alt="nav-gif" />
    </LeftPanelWrapper>
    <CustomModalContent>
      <CloseButton
        size="20px"
        onClick={onClose}
        styles={{
          top: '40px',
          right: '40px',
          [mediaQueries.mobile]: {
            top: '15px',
            right: '15px',
          },
        }}
      />
      <TextRow>
        <Title>{translate('new_navigation_notification_heading')}</Title>
        <Text>{translate('new_navigation_notification_text')}</Text>
      </TextRow>
      <PrimaryButton
        tag={translate('got_it_button')}
        style={{
          margin: '0 auto',
          background: palette.blue,
          color: palette.white,
          border: 'none',
        }}
        onClick={onClose}
      />
    </CustomModalContent>
  </Modal>
)
